import { sources } from "@common/enums/SourceEnum";
import { TranslationKeys } from "src/@types/i18next";

export type ConsumerFinancingStep = {
  id: number;
  nameTranslation: TranslationKeys["common"] | TranslationKeys["purchase"];
  alternateAdminNameTranslation?:
    | TranslationKeys["common"]
    | TranslationKeys["purchase"];
  order: number;
  href: string;
  isPointOfNoReturn: boolean;
};

export const consumerFinancingDetailsStep: ConsumerFinancingStep = {
  id: 13,
  nameTranslation: "common:vehicle_details",
  order: 1,
  href: "/financing/vehicle-details",
  isPointOfNoReturn: false,
};

export const consumerFinancingPersonalInfoStep: ConsumerFinancingStep = {
  id: 14,
  nameTranslation: "purchase:personal_info",
  order: 2,
  href: "/financing/personal-info",
  isPointOfNoReturn: false,
};

export const consumerFinancingFinancingStep: ConsumerFinancingStep = {
  id: 15,
  nameTranslation: "common:confirm",
  order: 3,
  href: "/financing/confirm",
  isPointOfNoReturn: false,
};

export const consumerFinancingChecklistStep: ConsumerFinancingStep = {
  id: 18,
  nameTranslation: "purchase:checklist_title",
  order: 4,
  href: "/financing/checklist",
  isPointOfNoReturn: false,
};

export const allConsumerFinancingSteps = [
  consumerFinancingDetailsStep,
  consumerFinancingPersonalInfoStep,
  consumerFinancingFinancingStep,
  consumerFinancingChecklistStep,
];

export const getFirstStep = () => allConsumerFinancingSteps[0];

export const getNextStep = (currentStep: ConsumerFinancingStep) => {
  const steps = allConsumerFinancingSteps;
  const index = steps.findIndex((s) => s.id === currentStep.id);
  if (index === steps.length - 1 || index === -1) {
    return undefined;
  }
  return steps[index + 1];
};

export const getPreviousStep = (currentStep: ConsumerFinancingStep) => {
  const steps = allConsumerFinancingSteps;
  const index = steps.findIndex((s) => s.id === currentStep.id);

  if (index === 0 || index === -1) {
    return undefined;
  }

  return steps[index - 1];
};

export const getStepById = (id: number) =>
  allConsumerFinancingSteps.find((s) => s.id === id);

export const getStepPathname = (step: ConsumerFinancingStep) => step.href;

export const isStepAccessible = (
  currentStep: ConsumerFinancingStep,
  accessedStep: ConsumerFinancingStep,
  purchaseHasOverwriteCandidate = false
) => {
  if (currentStep.isPointOfNoReturn && !purchaseHasOverwriteCandidate) {
    return currentStep === accessedStep;
  }

  return accessedStep.order <= currentStep.order;
};

export const isValidConsumerFinancingSource = (source: string | undefined) =>
  source &&
  sources.find((s) => s.name.toLowerCase() === source.toLowerCase()) !==
    undefined;
